
<template>
  <v-app id="searchPlts">
    <v-main>
    <v-container fluid>  
    <v-card>
      <v-card-title>Currencies</v-card-title>
      <v-simple-table dense>
         <tbody v-for="(pltsRecord,i) in searchPlts" :key="i">
           <tr @click="$router.reload('/syst/ref/plts/onPlts/' + pltsRecord.plts_encrid)">
             <td>{{pltsRecord.land_code}}</td>
             <td>{{pltsRecord.plts_naam}}</td>
           </tr>  
         </tbody>  
       </v-simple-table>  
    </v-card>  
    </v-container>
    </v-main>
    <navBar title="Ares - Reference data" :home="true" type="referencedata"/>  
  </v-app>
</template>


<script>
import navBar from "@/components/ui/navbars/navbar.vue";
 export default {
  components: {
    navBar
  },
  data() {
    return {
      searchPlts: []
    }  
  },
  mounted() {
      this.$axios
        .post("ares/json/ares/syst/ref/plts/searchPlts.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "searchPlts"
          },
          searchPlts: {
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.searchPlts = res.data.searchPlts;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
};

</script> 
